import Api from '@/api/rest/ProjectFileAttachApi';

export default new Api();
